<template>
  <div>
    <basic-product-reg pack="delivery"></basic-product-reg>
  </div>
</template>

<script>
  import BasicProductReg from "../../product/BasicProductReg";

  export default {
    components: {BasicProductReg},
    name: "delivery-product-create"
  }
</script>

<style scoped>

</style>
